import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {OAuthService} from "angular-oauth2-oidc";
import {StorageService} from "../services/storage.service";
import {AuthConfigService} from "./auth-config.service";

@Injectable()
export class AccountGuardService implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router,
  ) {
  }

  canActivate(): boolean {
    if (!this.storageService.getPreference('account')) {
      this.router.navigate(['dashboard']);
      return false;
    }
    return true;
  }
}
